import { render, staticRenderFns } from "./WhatsAppAlertsPage.vue?vue&type=template&id=cb49d5ea"
import script from "./WhatsAppAlertsPage.vue?vue&type=script&lang=js"
export * from "./WhatsAppAlertsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports